import { render, staticRenderFns } from "./BookEntity.vue?vue&type=template&id=578a9834&scoped=true"
import script from "./BookEntity.vue?vue&type=script&lang=js"
export * from "./BookEntity.vue?vue&type=script&lang=js"
import style0 from "./BookEntity.vue?vue&type=style&index=0&id=578a9834&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a9834",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('578a9834')) {
      api.createRecord('578a9834', component.options)
    } else {
      api.reload('578a9834', component.options)
    }
    module.hot.accept("./BookEntity.vue?vue&type=template&id=578a9834&scoped=true", function () {
      api.rerender('578a9834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BookEntity.vue"
export default component.exports